import { render, staticRenderFns } from "./header2.vue?vue&type=template&id=7c74b88a&scoped=true&"
import script from "./header2.vue?vue&type=script&lang=js&"
export * from "./header2.vue?vue&type=script&lang=js&"
import style0 from "./header2.vue?vue&type=style&index=0&id=7c74b88a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c74b88a",
  null
  
)

export default component.exports